module.exports = __webpack_public_path__ + "static/media/button_close.fff553b4.png";